import { Config } from "../Config";
import { DataLoading } from "../DataLoading";
import { Activity } from "../Vertx/MeetingsApi/Activity";
import { DragDropFile } from "./DragDrop";
import { FamilleEnOrFile } from "./FamilleEnOr";
import { PointerValiderFile } from "./PointerValider";
import { QCMFile } from "./QCM";
import { ReordonnerFile } from "./Reordonner";
import { ScormFile } from "./Scorm";
import { SwipeFile } from "./Swipe";
import { WordGuessFile } from "./WordGuess";

// NOTE : peut-être que ceci n'est utilisé que par les jeux de plateau,  et pourrait donc être placé dans le code des jdp au lieu d'être mis là... Plaxé danbs le sdk car ca a servi aussi pour la gmapp

// NOTE 2 : une fois qu'on aura généralisé les ludipacks; on pourra peut être simplifier ce fichier...

// permet de convertir un .activities simplifié en json compréhensible par le serveur

/**
 * Permet de parcourir les activités
 *
 * @param {Activity} root - Le nœud racine de l'arbre.
 * @param {function(Activity, number): void} cb - Fonction appelée à chaque activity.
 */
// export function traverse(rootNode, cb) {
//   async function recurse(currentNode, index) {
//     cb(currentNode, index)
//     if(currentNode.Children) {
//       currentNode.Children.forEach((child, _index) => {
//         recurse(child, _index);
//       })
//     }
//   }
//   recurse(rootNode, 0)
// }

export async function traverseAsync(rootNode, cb) {
  async function recurse(currentNode, index) {
    await cb(currentNode, index)

    if(currentNode.Children) {
      for await (const [_index, child] of currentNode.Children.entries()) {
        await recurse(child, _index); // Attendre chaque appel récursif
      }
    }
  }
  await recurse(rootNode, 0)
}

export function traverse(rootNode, cb) {
  function recurse(currentNode, index, parent) {
    cb(currentNode, index, parent)

    if(currentNode.Children) {
      for (const [_index, child] of currentNode.Children.entries()) {
        recurse(child, _index, currentNode); // Attendre chaque appel récursif
      }
    }
  }
  recurse(rootNode, 0, null)
}



export const TYPES = {
  QCM: "QCM",
  QRL: "QRL",
  DRAGDROP: "DragDrop",
  REORDONNER: "Reordonner",
  WORDGUESS: "WordGuess",
  SWIPE: "Swipe",
  FAMILLE_EN_OR: "FamilleEnOr",
  POINTER_VALIDER: "PointerValider",
  SCORM: "Scorm"

  // QRL ?
}

/**
 * ETAPES :
 * * .data
 * * json slotted
 * * json dataref <- injection du ludipack
 * * json avec act peda
 */


export class ActivitiesConverter {

  scenarioPath
  ludipackPath
  constructor(scenarioPath, ludipackPath) {
    this.scenarioPath = scenarioPath
    this.ludipackPath = ludipackPath
  }

  async getActivitiesFileContent() {
    let DL = new DataLoading()

    let files = await DL.getAllFiles({
      scenario: this.scenarioPath
    }, "")

    return files.scenario

  }
  async dataToJsonSlots() {

    let scenarioConfigPath = this.scenarioPath.replace(".data", ".config.data") // par convention
    let DL = new DataLoading()

    let files = await DL.getAllFiles({
      scenario: this.scenarioPath,
      scenario_config: scenarioConfigPath
    }, "")

    let conf = new Config()
    conf.init(files.scenario_config)

    let basePath = this.scenarioPath.split("/")
    basePath.pop()
    basePath = basePath.join("/") + "/"

    let root = this.#makeRoot(conf, basePath)

    let challengesPath = root.InitData.Files.Challenges // basePath + "/" + conf.get("Files.Challenges")

    let challengesFile = challengesPath ? await DL.getFile(challengesPath, "challenge") : undefined

    let objPath = root.InitData.Files.Objectives
    if(objPath) {
      let objFile = await DL.getFile(objPath, "objectives")
      root.InitData.Objectives = objFile
    }

    let children = this.#makeChildren(files.scenario, challengesFile?.data)

    root.Children = children

    // ici il faut encapsuler les children dans un parent
    // la config InitData du parent vient du fichier de config du scenario

    return root

  }


  #makeRoot(config, basePath) {
    let root = {

      Type: config.get("Type", "ActivityPlateau"), // override ?
      Name: config.get("Name", "JdP"),
      SequencerSubMode: config.get("SequencerSubMode", "DEFERRED_SEQUENTIAL"),

      InitData : {
        MaxVictoryPoints: config.get("MaxVictoryPoints", 100),
        VictoryPointsLimit: config.get("VictoryPointsLimit", 75),
        DefaultActivitePedaPaliers: this.#_createPaliers(config.get("DefaultActPedaMaxActionPoints", 5)),
        PlateauDeplacementType: config.get("PlateauDeplacementType", "MANUAL"),
        Files: {}
      },

      Children: []
    }

    let Files = config.get("Files")
    if(Files) {
      for(let f in Files) {
        let file = Files[f]
        root.InitData.Files[f] = basePath + file
      }
    }


    if(config.get("PlateauPath")) {
      root.DataRef = config.get("PlateauPath")
    }
    if(config.get("pawn_colors")) {
      root.InitData.pawn_colors = config.get("pawn_colors")
    }

    // on peut spécifier les paliers en json au lieu d'utiliser maxactpedaactionpoints
    if(config.get("DefaultActivitePedaPaliers")) {
      try {
        root.InitData.DefaultActivitePedaPaliers = JSON.parse(config.get("DefaultActivitePedaPaliers"))
      }
      catch(err) {
        console.error("La config DefaultActivitePedaPaliers est erronnée : " + err.message)
      }
    }



    return root
  }

  #makeChildren(data, challenges) {
    // ici il va falloir reconstituer le scenario en json .activities

    // let _Challenges = new Challenges()
    // _Challenges.init(challenges)
    // au cas ou on change la structure de Challenges, j'oublierai à coup sur de le changer ici


    let challengeIdKey = challenges && Object.keys(challenges[0]).find(k => k.toLowerCase() === "id")

    return data
    .filter(row => !!row.Type)
    .map((row, index) => {

      let obj = {
        Name: row.Name,
        Type: row.Type,
        InitData: {}
      }

      if(row.Items) {
        let ids = row.Items.split(";").map(id => id.trim())
        // console.log("ids", ids)
        let itemsjson = ids.map(id => {

          if(!challenges) {
            console.error("Aucun fichier de challenges")
          }

          let i = challenges.find(c => c[challengeIdKey] === id)

          if(!i) {
            console.error(`L'item ${id} n'a pas été trouvé dans le fichier de challenges`)
            return
          }

          let obj =  {
            Id: i.ID,
            Image: i.Image,
            ItemImage: i.ItemImage,
            CellId: i.CellId,
            PV: this.#_int(i.PV),
            PV_per_user: this.#_int(i.PV_per_user),
            VictoryPoints: this.#_int(i.VictoryPoints),
            ChallengeId: i.ID,
            LifeSpan: this.#_int(i.LifeSpan),
            Blocker: i.Blocker,
            Position: i.Position,
            MoveCamera: i.MoveCamera
          }

          // pour éviter un bug côté java
          if(obj.LifeSpan === null) delete obj.LifeSpan

          return obj

        })

        obj.InitData.Items = itemsjson
      }

      if(row.SequenceID) {
        obj.InitData.SequenceID = row.SequenceID
      }

      if(this.#_exists(row.ActPedaMaxActionPoints)) {
        if(obj.Type.includes("Slot")) {
          obj.InitData.Paliers = this.#_createPaliers(row.ActPedaMaxActionPoints)
        }
        else {
          console.error(`Attention, une config ActPedaMaxActionPoints est mise sur une ligne qui n'est pas de type "Slot" (ligne ${index+1}) dans le fichier ${this.scenarioPath}`)
        }
      }

      if(this.#_exists(row.AddScoreActionPoints)) {
        obj.InitData.AddScore = {ActionPoints: this.#_int(row.AddScoreActionPoints)}
      }

      if(row.PlateauBackgrounds) {
        obj.InitData.Elements = row.PlateauBackgrounds
        .split(";")
        .map(backgroundData => {
           let [id, animation="appear"] = backgroundData.split(":")
           return {
              id: id.trim(),
              animation: animation.trim()
            }

        })

      }

      if(row.PlateauSectionsCases) {
        obj.InitData.Sections = row.PlateauSectionsCases
        .split(";")
        .map(sectionData => {
           let [id, visible="true"] = sectionData.split(":")

           return {
              id: id.trim(),
              visible: visible === "true"
            }
        })

      }

      if(row.PlateauCellsNexts) {
        obj.InitData.CellsNexts = row.PlateauCellsNexts
        .split(";")
        .map(cellsNextsInfos => {
           let [country_source_id, country_dest_id, add] = cellsNextsInfos.split(":")

            add = add === "1"

           return {
              source_id: country_source_id.trim(),
              dest_id: country_dest_id.trim(),
              add
            }
        })

      }

      if(row.PopupID) {
        obj.InitData.PopupID = row.PopupID
      }
      if(row.SlideID) {
        obj.InitData.SlideID = row.SlideID
      }


      // NOTE on traite d'abord les complete
      if(row.ObjectiveComplete) {
        if(!obj.InitData.Objective) obj.InitData.Objective = []

        let ids = row.ObjectiveComplete.split(";")
        obj.InitData.Objective = [...obj.InitData.Objective, ...ids.map(id => ({id, "action": "complete"}))]
      }
      if(row.ObjectiveActivate) {
        if(!obj.InitData.Objective) obj.InitData.Objective = []

        let ids = row.ObjectiveActivate.split(";")
        obj.InitData.Objective = [...obj.InitData.Objective, ...ids.map(id => ({id, "action": "activate"}))]
      }

      if(row.InitData && row.InitData.trim()) {
        try {

          let initdata_to_add = JSON.parse(row.InitData.trim())
          obj.InitData = Object.assign({}, obj.InitData, initdata_to_add)
        }
        catch(err) {
          console.error(`Erreur dans la cellule InitData  (ligne ${index+1}) dans le fichier ${this.scenarioPath}`)
          console.log("Err : ", err)
        }
      }


      if(obj?.InitData?.Duration) {
        obj.Duration = obj.InitData.Duration
      }
      else
        obj.Duration = 0



      return obj
    })

  }


  async slotsToDataRefs(scenarioJsonSlotted) {
    if(this.ludipackPath) {

      let DL = new DataLoading()
      let {data} = await DL.getFile(this.ludipackPath, "ludipack")

      data = data.filter(row => !!row.Type)
      console.log("SLOTS ! nombre d'activités peda dans le ludipack", data)
      let numSlot = 0

      // on parcourt le scenario
      // si on tombe sur un Slot, on le remplace par l'activity suivante du ludipack
      traverse(scenarioJsonSlotted, (node, index, parent) => {
        if(node.Type && node.Type.toLowerCase().trim() === "slot") {
          numSlot++
          let acts = data.filter(r => parseInt(r.SlotNumber) === numSlot)
          if(acts.length > 0) {
            // on y met la première activity
            node.Type = acts[0].Type
            node.DataRef = acts[0].DataRef
            if(acts[0].Name) node.Name = acts[0].Name

            for(let i = 1; i < acts.length; i++) {
              // pour les suivantes, on duplique et on insère après
              let newNode = {...node}
              node.Type = acts[i].Type
              node.DataRef = acts[i].DataRef
              if(acts[i].Name) node.Name = acts[i].Name

              if(parent) {
                parent.Children.splice(index, 0, newNode)
              }
            }
          }
          else {
            let act = data.shift()
            if(act) {
              node.Type = act.Type
              node.DataRef = act.DataRef
              if(act.Name) node.Name = act.Name
            }
            else {
              throw "Pas assez d'activités pédagogiques dans " + this.ludipackPath
            }

          }





        }
      })
    }
    console.log("scenarioJsonSlotted", scenarioJsonSlotted)
    return {...scenarioJsonSlotted}

  }

  async dataRefsToActivitiesPeda(scenarioWithDataRefs) {
    let DL = new DataLoading()

    let usedIds = {} // filepath:id => permet de ne pas piocher 2 fois la meme AP en cas de random ou de getByCateg

    // ici je loope et je chope les trucs

    await traverseAsync(scenarioWithDataRefs, async (node) => {
      if(node.DataRef) {
        console.log("DataRef", node.Name, node.DataRef)
        let type = node.Type

         if(type === TYPES.SCORM) {
          // explicitement, je return car je ne veux pas toucher à la DataRef en cas de Scorm : le front l'utilise telle quelle et le serveur n'en a pas besoin
          return
        }

        let [path] = node.DataRef.split(":")

        /* possibilités
          1 => filepath:id
          2 => filepath:categ=id_categ
          3 => filepath -> ex: plateau json à intégrer
          4 => filepath -> scorm, à laisser tel quel (juste le dataref)
        */

        // ouvrir le fichier
        let {data} = await DL.getFile(path)


        const fileMap = {
            [TYPES.QCM]: QCMFile,
            [TYPES.DRAGDROP]: DragDropFile,
            [TYPES.SWIPE]: SwipeFile,
            [TYPES.REORDONNER]: ReordonnerFile,
            [TYPES.WORDGUESS]: WordGuessFile,
            [TYPES.FAMILLE_EN_OR]: FamilleEnOrFile,
            [TYPES.POINTER_VALIDER]: PointerValiderFile,
        };



        if (fileMap[type]) {
          // ici c'est le cas d'une activity peda connue, on va chercher l'id / filter
          let actPedaFile = fileMap[type]
          let actPedaFileInstance = new actPedaFile(data, path);
          let activityData = this.#getActivityPedaData(actPedaFileInstance, node.DataRef, usedIds)
          node.InitData.Data = activityData
          return
        }

        // ici, il ne s'agint pas d'une activity peda, ca peut être le json du plateau par exemple. Dans ce cas, met le contenu entier du fichier dans data
        node.InitData.Data = data


      }
    })

    return scenarioWithDataRefs
  }


  async ludipackToActivitiesPeda(scenarioJsonSlotted) {
    let DL = new DataLoading()

    // avant tout, on chope le plateau en json si nécessaire
    if(scenarioJsonSlotted.DataRef) {
      let {data} = await DL.getFile(scenarioJsonSlotted.DataRef, "plateau")
      scenarioJsonSlotted.InitData.Data = data
    }

    // on ouvre les fichiers d'activities
    let filesToGet = {
      pack: "pack.data",
      [TYPES.QCM]: "activities/qcm.data",
      [TYPES.DRAGDROP]: "activities/dragdrop.data",
      [TYPES.SWIPE]: "activities/swipe.data",
      [TYPES.WORDGUESS]: "activities/wordguess.data",
      [TYPES.SCORM]: "activities/scorm.data"
     }

    let files = await DL.getAllFiles(filesToGet, this.ludipackPath + "/")
    // on remplace les .data bruts par les Files parsées
    files[TYPES.QCM] = new QCMFile(files[TYPES.QCM])
    files[TYPES.DRAGDROP] = new DragDropFile(files[TYPES.DRAGDROP])
    files[TYPES.SWIPE] = new SwipeFile(files[TYPES.SWIPE])
    files[TYPES.WORDGUESS] = new WordGuessFile(files[TYPES.WORDGUESS])
    files[TYPES.SCORM] = new ScormFile(files[TYPES.SCORM])

    let ActPedaTypes = Object.values(TYPES)

    let pack = []
    let chapter
    files.pack.forEach(row => {
      if(row.type === "chapter") {
        chapter = []
        pack.push(chapter)
      }

      if(ActPedaTypes.includes(row.type)) {
        chapter.push(row)
      }
    })

    traverse(scenarioJsonSlotted, (node, index, parent) => {
      if(node.Type && node.Type.toLowerCase().trim().includes("slot")) {
        let [_, chapterIndex ] = node.Type.split(":")
        let ap_ref

        if(chapterIndex !== undefined) {
          // ici on a spécifié qu'on veut une AP d'un chapitre particulier
          // on le récupère
          if(pack.length >= chapterIndex) {
            ap_ref = pack[chapterIndex -1].shift() // on récup la première act du chapitre mentionné. J'ai mis -1 car on va pas commencer à 0 dans le fichier de scenario
          }
        }
        else {
          // ici choper la première act dispo et la retirer
          for(let i = 0; i < pack.length; i++) {
            let chapter = pack[i]
            if(chapter.length > 0) {
              ap_ref = chapter.shift() // on récup la première act dispo du premier chapitre dispo
              break;
            }
          }

        }


        if(ap_ref) {

          // ici on chope l'ap dans la file correspondant
          let AP = files[ap_ref.type].get(ap_ref.id)

          node.Type = ap_ref.type
          if(ap_ref.type === TYPES.SCORM) {
            node.DataRef = this.ludipackPath + "/" + AP.Path
          }
          else {
            node.InitData.Data = AP
          }
        }
      }
    })
    // on les charge dans le scenario dans les slots
    // pour le  si trop d'act, tant pis, si pas assez tant pis
    console.log("scenarioJsonSlotted", scenarioJsonSlotted)
    return {...scenarioJsonSlotted}
    // renvoyer le scenario avec les données
  }
  #getActivityPedaData (actPedaFileInstance, DataRef, usedIds) {
    // ici on a la dataref, on sait qu'il faut la chercher précisément dans ce fichier d'activities peda
    let [filepath, filter] = DataRef.split(":")

    if(usedIds[filepath] === undefined) {
      usedIds[filepath] = []
    }

    // si la DataRef est juste un fichier, on renvoie tout le fichier
    if(!filter) throw "Aucun id ou filtre spécifié pour cette DataRef : " + DataRef

    let id

    if(filter.includes("=")) {
      // ici c'est un filter, on le splitte en tant que Colonne=>Searchvalue
      let [column, value] = filter.split("=")

      // let possibleElts = f.filter(el => el[column] === value && !usedIds[filepath].includes(el.ID))
      let possibleElts = actPedaFileInstance.all.filter(el => el[column] === value && !usedIds[filepath].includes(el.ID))

      if(possibleElts.length > 0) {
        let randomIndex = Math.floor(Math.random() * possibleElts.length)
        id = possibleElts[randomIndex].ID
      }
    }
    else {
      id = filter
    }


    // TODO ici mettre en place une methode qui ne renverrait que les champs nécessaires aux données, au lieu d'avoir des champs non utiles dans le json de données (comme result, etc)
    let el = actPedaFileInstance.get(id)

    if(!el) {
      throw `Impossible de trouver un élément pour cette DataRef: ${DataRef}`
    }
    usedIds[filepath].push(id)
    return el
  }

  /**
   *
   * @param {number} ActionPoints le nombre d'action points du premier palier. On calcule les autres paliers
   */
  #_createPaliers(ActionPoints, nbPaliers = 3) {
    let paliers = []
    for(let i = 0; i < nbPaliers; i++ ) {

      let part = 0.99 / nbPaliers
      let ap = Math.max(ActionPoints - i, 0)

      paliers.push({
        percent: Math.round(part * (i+1) * 100) / 100,
        ActionPoints: ap
      })
    }
    paliers.push({
      percent: 1,
      ActionPoints: Math.max(ActionPoints - nbPaliers, 0)
    })

    return paliers
  }


  // utilisée pour tester la nullité tout en permettant le "" ou le 0
  #_exists(val) {
    return val !== null && val !== undefined
  }

  #_int(val) {
    const parsed = parseInt(val);
    return isNaN(parsed) ? null : parsed;
  }
}




export function replaceSlots(file, loadFiles) {
  if(!file) throw "replaceSlots : aucun fichier"

  var templateToUse = file.data
  .filter(line => !!line.Type)
  .find(line => line.Type.toLowerCase() === "template")

  if(!templateToUse) throw "Il manque le template dans le fichier"

  let templateFilename = templateToUse.DataRef
  if(!templateFilename) throw "Pas de référence de template"
  return loadFiles([templateFilename])
  .then((filesObj) => {
    let templatecontent = filesObj[templateFilename]

    let activitesPeda = file.data
    .filter(line => !!line.Type)
    .filter(line => line.Type.toLowerCase() !== "template")

    traverse(templatecontent, node => {

      if(node.Type && node.Type.toLowerCase().trim() === "slot") {
        let act = activitesPeda.shift()
        if(act) {
          node.Type = act.Type
          node.DataRef = act.DataRef
          if(act.Name) node.Name = act.Name
        }
        else {
          throw "Pas assez d'activités pédagogiques dans " + file.name
        }
      }
    })
    return {...file, data: templatecontent}
  })
}
export function replaceSlots2(scenario, ludipack) {

    let activitesPeda = ludipack
    .filter(line => !!line.Type) // la ligne a bien un Type


    traverse(scenario, node => {
      if(node.Type && node.Type.toLowerCase().trim() === "slot") {
        let act = activitesPeda.shift()
        if(act) {
          node.Type = act.Type
          node.DataRef = act.DataRef
          if(act.Name) node.Name = act.Name
        }
        else {
          throw "Pas assez d'activités pédagogiques dans " + file.name
        }
      }
    })
    return {...scenario}
}



/**
 * Traite les fichiers d'activité bruts (= non enrichi par les datarefs).
 *
 * @param {Object} rootActivity - l'objet "json" du fichier .activities
 * @param {function(): Promise<Object>} loadFiles - Une fonction qui charge les fichiers et renvoie une Promise.
 * La Promise résout un objet qui a en clé le path, et en valeur le contenu du fichier
 */
export function processRawActivityFiles(rootActivity, loadFiles, legacyMode=false) {
  // 1 on récupère les fichiers à charger
  let [fileRefs, types] = getDataRefs(rootActivity)

  // 2 on les charge. Attention, dans les apps on veut les charger via le DataLoading, dans la gmapp, on utilise l'api du CMS, d'ou le fait de passer une fonction externe
  return loadFiles(fileRefs)
  .then( files => {

    // Attention, il faut d'abord convertir les fichiers d'activities peda (ex: QCM)
    // dans leurs classes respectives car il y a parfois des objets sur plusieurs rows et ca les combine

    Object.keys(files)
    .forEach(filepath => {
      let type = types[filepath]
      let fileContent = files[filepath]

      switch(type) {
        case TYPES.QCM :
          files[filepath] = new QCMFile(fileContent, filepath)
          break;
        case TYPES.DRAGDROP :
          files[filepath] = new DragDropFile(fileContent, filepath)
          break;
        case TYPES.SWIPE :
          files[filepath] = new SwipeFile(fileContent, filepath)
          break;
        case TYPES.REORDONNER :
          files[filepath] = new ReordonnerFile(fileContent, filepath)
          break;
        case TYPES.WORDGUESS :
          files[filepath] = new WordGuessFile(fileContent, filepath)
          break;
        case TYPES.FAMILLE_EN_OR :
          files[filepath] = new FamilleEnOrFile(fileContent, filepath)
          break;
        case TYPES.POINTER_VALIDER :
          files[filepath] = new PointerValiderFile(fileContent, filepath)
          break;
      }
    })

    // je peux maintenant reparcourir les activities, et transformer le DataRef en contenu
    let updatedRootActivity = convertFilesToJSONActivities(rootActivity, files, legacyMode)
    return updatedRootActivity
  })

}



/**
 * passe les activities 1 par 1, et renvoie les DataRafs uniques
 * @param {Object} rootActivity l'objet "json" d'un fichier d'activities
 * @returns {Array<string>} un array des path vers les fichiers à charger
 */
export function getDataRefs(rootActivity) {
  let uniqueDataRefs = new Set()
  let types = {}
  let ValidTypes = Object.values(TYPES)
  traverse(rootActivity, (node) => {
    if(node.DataRef) {
      let [path] = node.DataRef.split(":")
      uniqueDataRefs.add(path)
      ValidTypes.forEach(t => {
        if(t.toLowerCase() === node.Type.toLowerCase()) types[path] = t
      })

    }
  })

  return [Array.from(uniqueDataRefs), types]
}


/**
 *
 * @param {Object} rootActivity
 * @param {*} files
 * @returns
 */
export function convertFilesToJSONActivities(rootActivity, files, legacyMode=false) {
  let usedIds = {}
  if(legacyMode) {

    traverse(rootActivity, (activity) => {

      if(activity.Type === TYPES.QCM) {
        let el = getElement(activity.DataRef, files, usedIds)

        if(!activity.InitData) activity.InitData = {}
        activity.InitData.QCM = el
      }

      if(activity.Type === TYPES.DRAGDROP) {
        let el = getElement(activity.DataRef, files, usedIds)

        if(!activity.InitData) activity.InitData = {}
        activity.InitData.DragDrop = el
      }


      if(activity.Type === TYPES.WORDGUESS) {
        let el = getElement(activity.DataRef, files, usedIds)

        if(!activity.InitData) activity.InitData = {}
        activity.InitData.WordGuess = el
      }
    })

  }
  else {

    traverse(rootActivity, (activity) => {
      if(activity.DataRef && activity.Type !== TYPES.SCORM) {
        let el = getElement(activity.DataRef, files, usedIds)
        if(!activity.InitData) activity.InitData = {}
        activity.InitData.Data = el
      }
    })

  }
  return rootActivity

}



function getElement(DataRef, files, usedIds) {
  let [filepath, filter] = DataRef.split(":")
  let f = files[filepath]
  if(usedIds[filepath] === undefined) {
    usedIds[filepath] = []
  }


  if(!f) {
    console.log("files", files)
    throw `Impossible de trouver le fichier: ${filepath}`
  }


  // si la DataRef est juste un fichier, on renvoie tout le fichier
  if(!filter) return f




  let id = filter

  if(filter.includes("=")) {
    // ici c'est un filter, on le splitte en tant que Colonne=>Searchvalue
    let [column, value] = filter.split("=")

    // let possibleElts = f.filter(el => el[column] === value && !usedIds[filepath].includes(el.ID))
    let possibleElts = f.all.filter(el => el[column] === value && !usedIds[filepath].includes(el.ID))

    if(possibleElts.length > 0) {
      let randomIndex = Math.floor(Math.random() * possibleElts.length)
      id = possibleElts[randomIndex].ID
    }
  }
  if(f.get === undefined) throw `Erreur sur cette DataRef ${DataRef}. Le type est inconnu.`
  let el = f.get(id)

  if(!el) {
    throw `Impossible de trouver un élément pour cette DataRef: ${DataRef}`
  }
  usedIds[filepath].push(id)
  return el
}